/**
 * Created by zqy on 18/12/22.
 */
export default class StorageUtil {
    constructor() {
        console.log(new Error('静态类不需要实例化'))
    }
    static setLocal(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
    static getLocal(key) {
        let value = window.localStorage.getItem(key);
        return JSON.parse(value);
    }
    static setSession(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    static getSession(key) {
        let value = window.sessionStorage.getItem(key);
        return JSON.parse(value);
    }
    static removeLocaIteml(key) {
        window.localStorage.removeItem(key);
    }
    static removeSessionItem(key) {
        window.sessionStorage.removeItem(key);
    }
    static clearAllLocal() {
        window.localStorage.clear();
    }
    static clearAllSession() {
        window.sessionStorage.clear();
    }
}